<mat-card class="register-card">
    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
    <h2>Registration</h2>
    <form [formGroup]="registerForm" (ngSubmit)="handleSubmit()">
      <!-- Name Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput type="text" formControlName="name" required />
        <mat-error *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
          {{ getErrorMessage('name') }}
        </mat-error>
      </mat-form-field>
  
      <!-- Email Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" required />
        <mat-error *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
          {{ getErrorMessage('email') }}
        </mat-error>
      </mat-form-field>
  
      <!-- Password Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" required />
        <mat-error *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
          {{ getErrorMessage('password') }}
        </mat-error>
      </mat-form-field>
  
      <!-- City Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>City</mat-label>
        <mat-select formControlName="city" required>
          <mat-option *ngFor="let city of cities" [value]="city">{{ city }}</mat-option>
        </mat-select>
        <mat-error *ngIf="registerForm.get('city')?.invalid && registerForm.get('city')?.touched">
          {{ getErrorMessage('city') }}
        </mat-error>
      </mat-form-field>
  
      <!-- Register Button -->
      <button mat-raised-button color="primary" type="submit" [disabled]="registerForm.invalid">Register</button>
    </form>
  </mat-card>
  